import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import eventBus from '../components/eventBus/EventBus';

const Home                   = lazy(() => import('../pages/home/Home'));
const AboutUs                = lazy(() => import('../pages/aboutUs/AboutUs'));
const Gallery                = lazy(() => import('../pages/gallery/Gallery'));
const Product                = lazy(() => import('../pages/product/Product'));
const Contact                = lazy(() => import('../pages/contactUs/Contact'));
const AdminLogin             = lazy(() => import('../pages/adminLogin/AdminLogin'));
const AdminDash              = lazy(() => import('../pages/adminDash/AdminDash'));
const SubAdminLogin          = lazy(() => import('../pages/subAdminLogin/SubAdminLogin'));
const SubAdminDash           = lazy(() => import('../pages/subAdminDash/SubAdminDash'));
const DealerLogin            = lazy(() => import('../pages/dealerLogin/DealerLogin'));
const DealerDash             = lazy(() => import('../pages/dealerDash/DealerDash'));

const DealerForm             = lazy(() => import('../components/dealerForm/DealerForm'));
const CustomerForm           = lazy(() => import('../components/customerForm/CustomerForm'));
const VehicleInfo            = lazy(() => import('../components/vehicleInfo/VehicleInfo'));
const LetterOfIntent         = lazy(() => import('../components/letterOfIntent/LetterOfIntent'));
const RequestLetter          = lazy(() => import('../components/requestLetter/RequestLetter'));
const DownloadCertificate    = lazy(() => import('../components/downloadCertificate/DownloadCertificate'));
const Document               = lazy(() => import('../components/document/Document'));
const MissionVision          = lazy(() => import('../components/mission&Vision/Mission&Vision'));
const Form_22                = lazy(() => import('../components/form_22/Form_22'));
const DisplayActivationCode  = lazy(() => import('../components/DisplayActivationCode/DisplayActivationCode'));
const GenerateActivationCode = lazy(() => import('../components/generateActivationCode/GenerateActivationCode'));
const ModifyCNFCode          = lazy(() => import('../components/modifyCNFCode/ModifyCNFCode'));
const CreateProfileSubAdmin  = lazy(() => import('../components/createProfileSubAdmin/CreateProfileSubAdmin'));
const CreateQuotation        = lazy(() => import('../components/quotation/createQuotation'));
const DealerCustomerInfo     = lazy(() => import('../components/dealerCustomerInfo/DealerCustomerInfo'));
const DisplayCustomerInfo    = lazy(() => import('../components/displayCustomerInfo/DisplayCustomerInfo'));
const DisplayVehicleInfo     = lazy(() => import('../components/displayVehicleInfo/DisplayVehicleInfo'));
const DealerInfo             = lazy(() => import('../components/dealerInfo/DealerInfo'));
const SubAdminInfo           = lazy(() => import('../components/subAdminInfo/SubAdminInfo'));

const AppRoutes = () => {
    return (
        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>Loading...</div>}>
            <Routes>
                <Route path='/' Component={Home} />
                <Route path='/about' Component={AboutUs} />
                <Route path='/gallery' Component={Gallery} />
                <Route path='/product' Component={Product} />
                <Route path='/contact' Component={Contact} />
                <Route path='/mission' Component={MissionVision} />
                <Route path='/document' Component={Document} />

                <Route path='/DealerForm' Component={DealerForm} />
                <Route path='/customerForm' Component={CustomerForm} />
                <Route path='/VehicleInfo' Component={VehicleInfo} />
                <Route path='/LetterOfIntent' Component={LetterOfIntent} />
                <Route path='/RequestLetter' Component={RequestLetter} />
                <Route path='/DownloadCertificate' Component={DownloadCertificate} />
                <Route path='/form_22' Component={Form_22} />

                <Route path='/admin' Component={AdminLogin} />
                <Route path='/adminDash' Component={AdminDash} />
                <Route path='/displayActivationCode' Component={DisplayActivationCode} />
                <Route path='/generateActivationCode' Component={GenerateActivationCode} />
                <Route path='/modifyCNFCode' Component={ModifyCNFCode} />
                <Route path='/createProfileSubAdmin' Component={CreateProfileSubAdmin} />

                <Route path='/dealerLogin' Component={DealerLogin} />
                <Route path='/dealerDash' Component={DealerDash} />
                <Route path='/dealerInfo' Component={DealerInfo} />
                <Route path='/createQuotation' Component={CreateQuotation} />
                <Route path='/dealerCustomerInfo' Component={DealerCustomerInfo} />
                <Route path='/displayCustomerInfo' Component={DisplayCustomerInfo} />
                <Route path='/displayVehicleInfo' Component={DisplayVehicleInfo} />

                <Route path='/subAdminLogin' Component={SubAdminLogin} />
                <Route path='/subAdminDash' Component={SubAdminDash} />
                <Route path='/subAdminInfo' Component={SubAdminInfo} />

                <Route path='/eventBus' Component={eventBus} />
            </Routes>
        </Suspense>
    );
};

export default AppRoutes;
